import { render, staticRenderFns } from "./CardTestimoni.vue?vue&type=template&id=3f689f04&scoped=true&"
import script from "./CardTestimoni.vue?vue&type=script&lang=js&"
export * from "./CardTestimoni.vue?vue&type=script&lang=js&"
import style0 from "./CardTestimoni.vue?vue&type=style&index=0&id=3f689f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f689f04",
  null
  
)

export default component.exports